<template>  
  <h1>
    <span v-if="editing" >
      <el-input v-model="name" ></el-input>
      <el-button-group>
        <el-button type="success" icon="el-icon-fa-check" @click="confirm()" ></el-button>
        <el-button type="danger" icon="el-icon-fa-times" @click="cancel()" ></el-button>
      </el-button-group>
    </span>
    <span v-else >
      {{ board.name }}
      <i v-if="editable" class="el-icon-fa-pencil-square-o fakelink" @click="editing = true" ></i>
    </span>
  </h1>
</template>

<style scoped>
h1 i {
    vertical-align: super;
}
h1 .el-input {
    width: 60%;
}
h1 .el-button-group {
    position: relative;
    top: 4px;
}
</style>

<script>
  export default {
    props: {
      mode: {
        required: true,
        type: String
      }
    },
    data () {
      return {
        editing: false,
        name: null
      }
    },
    computed: {
      editable () {
        return this.mode === 'edit'
      },
      board () {
        return this.$store.state.board
      },
      realName () {
        return this.board.name
      }
    },
    watch: {
      realName () {
        this.name = this.realName
      }
    },
    methods: {      
     cancel () {
       this.editing = false
       this.name = this.realName
     },
     confirm () {
       this.editing = false
       this.$store.dispatch('updateBoard', {
         name: this.name
       })
     }
    }
  }
</script>



// WEBPACK FOOTER //
// node_modules/macarons/src/components/PortalTitle.vue